import { alertConstants as ac } from 'srcReact/Alert'
import { uuid } from 'srcReact/helpers/utils'

export const alertActions = {
  success,
  error,
  clear,
}

function success(message) {
  const id = uuid()
  return { type: ac.SUCCESS, message, id }
}

function error(message) {
  message = Array.isArray(message) ? message[0] : message
  const id = uuid()
  return { type: ac.ERROR, message, id }
}

function clear() {
  return { type: ac.CLEAR }
}
